import { LogLevel } from "@azure/msal-browser";
import { AppConfig } from "./config";

export const createMsalConfig = (config: AppConfig) => ({
    auth: {
        clientId: config.AZURE_ID,
        authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
        redirectUri: config.REDIRECT_URI,
        postLogoutRedirectUri: '/',
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        //console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        //console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
});

export const loginRequest = {
    scopes: ['User.Read', 'profile', 'openid', 'email'],
    forceRefresh: true,
};

export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
    forceRefresh: true,
};